import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackSearchFilteredParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackSearchFiltered";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackSearchFiltered = (
    parameters: PartialSpecific<TrackSearchFilteredParameters, "filter_name"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => ga.util.getEventTrackerHook(ga.track.searchFiltered, parameters, options);

export default useTrackSearchFiltered;
